// extracted by mini-css-extract-plugin
export default {"home_page":"Home_home_page__WNYKH"};